import React from 'react'

const ArrowRight = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/arrow-right',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M11.788 5l-.306.293 4.661 4.471H3v.47h13.144l-4.662 4.473.306.293L17 10z'
      fill='none'
      fillRule='evenodd'
      stroke={primaryColor}
    />
  </svg>
)

export default ArrowRight
